window.onscroll = function() {scrollFunction()};

$("[data-arrow-to-top]").on("click",function(e){
  e.preventDefault();
	$('html,body').animate({ scrollTop: 0 }, 'slow');
});

function scrollFunction() {

	var	bottom = $(window).scrollTop();
	var	bottomTrigger = ($(window).scrollTop() + $(window).height());

  if ($(window).scrollTop() > 20 && bottomTrigger < $(document).height()) {       
    $("[data-arrow-to-top]").css("bottom", "50px");   
  } else if (($(window).scrollTop() == "0")) {
    $("[data-arrow-to-top]").css("bottom", "-100px"); 
  }	else if (bottomTrigger == $(document).height()) {
    $("[data-arrow-to-top]").css("bottom", ($(".footer").outerHeight() + 30) + "px");       
  }    
}



// WEBPACK FOOTER //
// ./components/js-to-top.js